import {
  BarChart3,
  HandCoins,
  ReceiptText,
  Settings2,
  Sun,
} from 'lucide-react';
import type { ModuleSectionNavItem } from '../../../components/navigation/ModuleSectionNav';

export const DONATIONS_SECTION_ITEMS: ModuleSectionNavItem[] = [
  { id: 'dashboard', label: 'Dashboard', to: '/school/donations', end: true, icon: BarChart3 },
  { id: 'moderation', label: 'Moderation', to: '/school/donations/moderation', icon: HandCoins },
  { id: 'ledger', label: 'Ledger', to: '/school/donations/ledger', icon: ReceiptText },
  { id: 'settings', label: 'Settings', to: '/school/donations/settings', icon: Settings2 },
  { id: 'daily-honorees', label: 'Daily Honorees', to: '/school/donations/daily-honorees', icon: Sun },
];
